<template>
    <b-form @keydown="item.onKeydown($event)" @submit.prevent="handleSave">
        <b-card-body>
            <fieldset>
              <b-form-row>
                <b-col col>
                  <b-form-group
                      :invalid-feedback="item.errors.get('name')"
                      :label="$t('Projectname')"
                      :state="item.errors.has('name') ? false : null"
                      label-for="name"
                  >
                    <b-form-input
                        id="name"
                        v-model="item.name"
                        :readonly="$gate.deny('update',item)"
                        :state="item.errors.has('name') ? false : null"
                        name="name"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="auto">
                  <project-status-select
                      v-model="item.status"
                      :readonly="$gate.deny('update',item)"
                      :error="item.errors.get('status')"
                  />
                </b-col>
              </b-form-row>

                <b-form-group
                    :invalid-feedback="item.errors.get('project_number')"
                    :label="$t('Project number')"
                    :state="item.errors.has('project_number') ? false : null"
                    label-for="project_number"
                >
                    <b-form-input
                        id="project_number"
                        v-model="item.project_number"
                        :readonly="$gate.deny('update',item)"
                        :state="item.errors.has('project_number') ? false : null"
                        name="project_number"
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="item.errors.get('ordinal_mask')"
                    :label="$t('Ordinal mask')"
                    :state="item.errors.has('ordinal_mask') ? false : null"
                    label-for="ordinal_mask"
                >
                    <b-form-input
                        id="ordinal_mask"
                        v-model="item.ordinal_mask"
                        :readonly="$gate.deny('update',item)"
                        :state="item.errors.has('ordinal_mask') ? false : null"
                        name="ordinal_mask"
                    />
                </b-form-group>
            </fieldset>

          <fieldset>
            <b-form-row>
              <b-col cols="12" sm>
                <b-form-group
                :invalid-feedback="item.errors.get('contract_start')"
                :label="$t('Contract start')"
                :state="item.errors.has('contract_start') ? false : null"
                label-for="contract_start"
            >
              <b-form-datepicker
                  id="contract_start"
                  v-model="item.contract_start"
                  :locale="$i18n.locale"
                  :readonly="$gate.deny('update',item)"
                  :state="item.errors.has('contract_start') ? false : null"
              />
            </b-form-group>
              </b-col>

              <b-col cols="12" sm>
                <b-form-group
                :invalid-feedback="item.errors.get('contract_end')"
                :label="$t('Contract end')"
                :state="item.errors.has('contract_end') ? false : null"
                label-for="contract_end"
            >
              <b-form-datepicker
                  id="contract_end"
                  v-model="item.contract_end"
                  :locale="$i18n.locale"
                  :readonly="$gate.deny('update',item)"
                  :state="item.errors.has('contract_end') ? false : null"
            />
            </b-form-group>
              </b-col>
            </b-form-row>
          </fieldset>

            <fieldset>
                <b-form-group
                    :invalid-feedback="item.errors.get('address_id')"
                    :label="$t('Object')"
                    :state="item.errors.has('address_id') ? false : null"
                    label-for="address_id"
                >
                    <address-select
                        v-if="$gate.allow('update',item)"
                        id="address_id"
                        v-model="item.address"
                        :state="item.errors.has('address_id') ? false : null"
                        hide-create
                        name="address"
                        @input="item.address_id = $event ? $event.id : null"
                    />
                    <address-info
                        v-else
                        :address="address"
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="item.errors.get('architect_address_id')"
                    :label="$t('Architect address')"
                    :state="item.errors.has('architect_address_id') ? false : null"
                    label-for="architect_address_id"
                >
                    <address-select
                        v-if="$gate.allow('update',item)"
                        id="architect_address_id"
                        v-model="item.architect_address"
                        :state="item.errors.has('architect_address_id') ? false : null"
                        hide-create
                        name="architect_address_id"
                        @input="item.architect_address_id = $event ? $event.id : null"
                    />
                    <address-info
                        v-else
                        :address="architectAddress"
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="item.errors.get('client_address_id')"
                    :label="$t('Client address')"
                    :state="item.errors.has('client_address_id') ? false : null"
                    label-for="client_address_id"
                >
                    <address-select
                        v-if="$gate.allow('update',item)"
                        id="client_address_id"
                        v-model="item.client_address"
                        :state="item.errors.has('client_address_id') ? false : null"
                        hide-create
                        name="client_address_id"
                        @input="item.client_address_id = $event ? $event.id : null"
                    />
                    <address-info
                        v-else
                        :address="clientAddress"
                    />
                </b-form-group>
            </fieldset>

            <fieldset>
                <b-form-group
                    :invalid-feedback="item.errors.get('customer_id')"
                    :label="$t('Customer')"
                    :state="item.errors.has('customer_id') ? false : null"
                    label-for="customer"
                >
                    <resource-select
                        v-if="$gate.allow('update',item)"
                        v-model="item.customer"
                        :state="item.errors.has('customer_id') ? false : null"
                        resource="customers"
                        @input="item.customer_id = $event ? $event.id : null"
                    />
                    <b-input
                        v-else
                        :value="customer"
                        readonly
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="item.errors.get('building_type')"
                    :label="$t('Building type')"
                    :state="item.errors.has('building_type') ? false : null"
                    label-for="building_type"
                >
                    <b-form-input
                        id="building_type"
                        v-model="item.building_type"
                        :placeholder="$t('building_type_placeholder')"
                        :readonly="$gate.deny('update', item)"
                        :state="item.errors.has('building_type') ? false : null"
                        name="building_type"
                    />
                </b-form-group>
            </fieldset>

            <fieldset>
                <b-form-group
                    :invalid-feedback="item.errors.get('project_managers')"
                    :label="$t('Project manager')"
                    :state="item.errors.has('project_managers') ? false : null"
                    label-for="project_managers"
                >
                    <resource-select
                        v-if="$gate.allow('update',item)"
                        id="project_managers"
                        v-model="item.project_managers"
                        :state="item.errors.has('project_managers') ? false : null"
                        multiple
                        name="project_managers"
                        resource="users"
                    />
                    <b-input
                        v-else
                        :value="projectManagers"
                        readonly
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="item.errors.get('construction_managers')"
                    :label="$t('Construction manager')"
                    :state="item.errors.has('construction_managers') ? false : null"
                    label-for="construction_managers"
                >
                    <resource-select
                        v-if="$gate.allow('update',item)"
                        id="construction_managers"
                        v-model="item.construction_managers"
                        :state="item.errors.has('construction_managers') ? false : null"
                        multiple
                        name="construction_managers"
                        resource="users"
                    />
                    <b-input
                        v-else
                        :value="constructionManagers"
                        readonly
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="item.errors.get('foreman_id')"
                    :label="$t('Foreman')"
                    :state="item.errors.has('foreman_id') ? false : null"
                    label-for="foreman"
                >
                    <resource-select
                        v-if="$gate.allow('update',item)"
                        id="foreman"
                        v-model="item.foremen"
                        :state="item.errors.has('foreman_id') ? false : null"
                        multiple
                        name="foremen"
                        resource="users?role=foreman"
                    />
                    <b-input
                        v-else
                        :value="foremen"
                        readonly
                    />
                </b-form-group>
            </fieldset>
        </b-card-body>

        <b-card-footer v-if="$gate.allow('update',item)">
            <b-button
                :disabled="item.busy"
                trasition="fade"
                type="submit"
                variant="primary"
            >
                {{ project ? $t('Save'): $t('Create') }}
                <b-spinner v-show="item.busy" small />
            </b-button>
        </b-card-footer>
</b-form>
</template>

<script>
    import Form from 'vform'
    import itemMixin from "@/mixins/itemMixin";
    import {PROJECT_STATUSES, STAFF_MEMBER_ROLES} from "@/constants";
    import AddressSelect from "@/components/selects/AddressSelect";
    import AddressInfo from "@/components/selects/AddressInfo";
    import ResourceSelect from "@/components/selects/ResourceSelect";
    import ProjectStatusSelect from "@/components/selects/ProjectStatusSelect";

    export default {
        name: 'ProjectsOverview',
        components: {
          ProjectStatusSelect,
            ResourceSelect,
            AddressInfo,
            AddressSelect,
        },
        mixins:[itemMixin],
        props: {
            project: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                lazy: true,
                item: new Form({
                    model_name: 'project',
                    status: PROJECT_STATUSES.CREATED
                }),
                disabilitiesForm: new Form(),
                STAFF_MEMBER_ROLES,
            }
        },
        computed: {
            resourceName() {
                return 'projects';
            },

            address() {
                return this.item.address || {};
            },

            architectAddress() {
                return this.item.architect_address || {};
            },

            clientAddress() {
                return this.item.client_address || {};
            },

            customer() {
                return this.item.customer ? this.item.customer.name : null
            },

            foremen() {
                return this.item.foremen ? this.item.foremen.map(({name}) => name).join(', ') : null
            },

            projectManagers() {
                return this.item.project_managers ? this.item.project_managers.map(({name}) => name).join(', ') : null
            },


            constructionManagers() {
                return this.item.construction_managers ? this.item.construction_managers.map(({name}) => name).join(', ') : null
            },
        },

        watch: {
            project: {
                handler(newProjectValue) {
                    this.setData(newProjectValue);
                },
                immediate: true,
                // deep: true
            }
        },

        methods: {
            setData(data) {
                let defaults = {
                    model_name: 'project',
                    status: PROJECT_STATUSES.CREATED
                };


                this.$set(this, 'item', new Form(Object.assign(defaults, data)))
            },
        },
    }
</script>
